import script from "./MainBox.vue?vue&type=script&setup=true&lang=js"
export * from "./MainBox.vue?vue&type=script&setup=true&lang=js"

import "./MainBox.vue?vue&type=style&index=0&id=5406e5b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5406e5b8"]])

export default __exports__